import { CONSENTABLE_SERVICES, type ConsentableService } from './services';
import { DEMO_SERVICE, isDemoEnabled } from './demoService';

/** The registry the app actually runs: production entries plus the dev demo. */
export function consentRegistry(): readonly ConsentableService[] {
  return isDemoEnabled() ? [...CONSENTABLE_SERVICES, DEMO_SERVICE] : CONSENTABLE_SERVICES;
}
